export default "__VITE_ASSET__CK4EpL7L__"